export default "__VITE_ASSET__d21c9439__"